import { placement, Tooltip } from "@whatslly/ui-components/Tooltip";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
import commonStyles from "../../pages/common.module.scss";
import React from "react";
export const MoreInfoQuestionMark: React.FC<{ tooltipText: string; tooltipPlacement?: placement; tooltipClassName?: string }> = ({
  tooltipText,
  tooltipClassName,
  tooltipPlacement,
}) => {
  return (
    <Tooltip value={tooltipText} placement={tooltipPlacement ?? "bottom"} design={"analytics"} className={tooltipClassName}>
      <Svg iconName="more-info-question-mark" className={commonStyles.moreInfoQuestionMark} />
    </Tooltip>
  );
};
